import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const SMSDialog = ({ open, onClose, onSend, message, setMessage, loading }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={() => !loading && onClose()}>
      <DialogTitle>{t("esim.smsDialog.title")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={t("esim.smsDialog.messageLabel")}
          fullWidth
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("common.actions.cancel")}
        </Button>
        <Button onClick={onSend} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : t("common.actions.send")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SMSDialog;
